import type { PersistedEntitiesState } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Actions = any;

const DEFAULT_STATE = {
	ruleSets: {},
	blueprints: {},
} as const;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: PersistedEntitiesState = DEFAULT_STATE, action: Actions) => {
	switch (action.type) {
		default: {
			return state;
		}
	}
};
